import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTheme } from 'styled-components';
import { useSubscribe } from '@/js/libs/observable';
import { Button } from '../../Controls/Button';
import Icons from '../../Elements/Icons';
import { Loader } from '../../Elements/Loader';
import Typography from '../../Typography';
import { FileActions, FileAttributes, FileName, FileStatusCard, ProgressBarAppearance } from './FileStatus.styled';
import { UploadingError } from './UploadingError';
const ProgressBar = ({ progress$, customColor }) => {
    const progress = useSubscribe(progress$);
    // Concat is much faster
    const width = progress + '%';
    return (_jsx(ProgressBarAppearance, { "$customColor": customColor, "data-testid": 'progress-bar', children: _jsx("div", { style: { width } }) }));
};
const ProgressValue = ({ progress$ }) => {
    const progress = useSubscribe(progress$);
    return _jsx("span", { children: progress + '%' });
};
export const FileStatus = ({ file, onRemove, progress$, error, }) => {
    const theme = useTheme();
    const finished = useSubscribe((ctx) => {
        const progress = progress$ ? ctx.spy(progress$) : null;
        return progress === null ? true : progress === 100;
    });
    return (_jsxs(FileStatusCard, { "data-testid": 'file-status-card', children: [_jsxs(FileAttributes, { children: [_jsx(FileName, { children: _jsx(Typography.TextMedium, { children: file.file.name }) }), _jsxs(FileActions, { children: [!error &&
                                progress$ &&
                                (finished ? (_jsx(Icons.Check, { size: 20, color: theme.colors.positive100 })) : (_jsx(Loader, { fill: theme.colors.grey100_1, dataTestId: 'loader' }))), progress$ && !finished && _jsx(ProgressValue, { "progress$": progress$ }), onRemove && (finished || error) && (_jsx(Button, { ghost: true, onClick: () => onRemove(file), children: _jsx(Icons.Delete, { size: 20, color: theme.colors.critical100 }) }))] })] }), progress$ && !finished && _jsx(ProgressBar, { customColor: error ? theme.colors.critical70 : undefined, "progress$": progress$ }), error && _jsx(UploadingError, { children: error })] }));
};
